<template>

  <ul class="c-list-socials">

    <li class="c-list-socials__item">

      <a :href="socials.linkedin" target="_blank" rel="noopener" class="c-list-socials__link" title="Me retrouver sur Linkedin">

        <svg class="c-list-socials__svg" width="29" height="29" viewBox="0 0 29 29" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M6.73577 9.53564H0.594849V28.4143H6.73577V9.53564Z" />
          <path d="M23.4638 9.75553C23.3994 9.73408 23.3351 9.71262 23.2707 9.69117C23.1903 9.66972 23.1044 9.65899 23.024 9.6429C22.6968 9.57854 22.3429 9.53027 21.9245 9.53027C18.3419 9.53027 16.0732 12.1314 15.3277 13.1397V9.53564H9.17609V28.4143H15.317V18.1168C15.317 18.1168 19.9562 11.6541 21.9138 16.4006C21.9138 20.6376 21.9138 28.4143 21.9138 28.4143H28.0547V15.6766C28.0547 12.8233 26.1025 10.4474 23.4638 9.75553Z" />
          <path d="M3.59827 6.96143C5.25701 6.96143 6.60169 5.61675 6.60169 3.95801C6.60169 2.29927 5.25701 0.95459 3.59827 0.95459C1.93953 0.95459 0.594849 2.29927 0.594849 3.95801C0.594849 5.61675 1.93953 6.96143 3.59827 6.96143Z" />
        </svg>

      </a>

    </li>

    <!-- <li class="c-list-socials__item">

      <a :href="socials.github" target="_blank" rel="noopener" class="c-list-socials__link">

        <svg class="c-list-socials__svg" width="29" height="28" viewBox="0 0 29 28" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M14.2778 0.538574C6.40252 0.538574 0.0198364 6.84045 0.0198364 14.6199C0.0198364 20.8378 4.1023 26.1155 9.76651 27.9736C10.4794 28.1079 10.7412 27.6713 10.7412 27.2964C10.7412 26.9606 10.73 26.0763 10.7245 24.901C6.75897 25.7517 5.92354 23.0149 5.92354 23.0149C5.27747 21.3918 4.33622 20.9553 4.33622 20.9553C3.04409 20.0822 4.43647 20.099 4.43647 20.099C5.86784 20.1942 6.61973 21.5486 6.61973 21.5486C7.88958 23.7033 9.95587 23.0765 10.7746 22.7183C10.9027 21.806 11.2703 21.1904 11.6769 20.8378C8.5078 20.4852 5.18279 19.2763 5.18279 13.8811C5.18279 12.342 5.73417 11.0883 6.64757 10.1033C6.48606 9.74513 6.00708 8.31798 6.7701 6.37592C6.7701 6.37592 7.96198 6.00095 10.6911 7.81987C11.8328 7.50646 13.0414 7.34975 14.2555 7.34415C15.4697 7.34975 16.6783 7.50646 17.82 7.81987C20.5268 6.00095 21.7243 6.37592 21.7243 6.37592C22.4929 8.31238 22.0083 9.74513 21.8691 10.1033C22.7769 11.0883 23.3283 12.342 23.3283 13.8811C23.3283 19.2875 19.9977 20.4796 16.8231 20.8266C17.3244 21.2519 17.7866 22.1138 17.7866 23.429C17.7866 25.3151 17.7699 26.8262 17.7699 27.2852C17.7699 27.6545 18.0205 28.0967 18.7502 27.9512C24.4534 26.1099 28.5358 20.8322 28.5358 14.6199C28.5358 6.84045 22.1531 0.538574 14.2778 0.538574Z" fill="#E6D6D0"/>
        </svg>

      </a>

    </li> -->

    <!-- <li class="c-list-socials__item">

      <a :href="socials.codepen" target="_blank" rel="noopener" class="c-list-socials__link">

        <svg class="c-list-socials__svg" width="29" height="28" viewBox="0 0 29 28" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M1.07736 19.4324L13.6274 27.7993C14.0564 28.0621 14.5123 28.0675 14.9467 27.7993L27.4967 19.4324C27.8185 19.2179 28.017 18.8371 28.017 18.4509V10.084C28.017 9.70325 27.8185 9.31708 27.4967 9.10255L14.9467 0.735678C14.5177 0.472873 14.0618 0.472873 13.6274 0.735678L1.07736 9.10255C0.755569 9.31708 0.557129 9.69788 0.557129 10.084V18.4509C0.557129 18.8317 0.755569 19.2179 1.07736 19.4324ZM13.1071 24.6134L3.86625 18.4509L7.99059 15.6941L13.1071 19.1106V24.6134ZM15.467 24.6134V19.1106L20.5835 15.6941L24.7078 18.4509L15.467 24.6134ZM25.6571 16.2412L22.702 14.2675L25.6571 12.2884V16.2412ZM15.467 3.92153L24.7078 10.084L20.5835 12.8408L15.467 9.42435V3.92153ZM14.287 11.4785L18.4543 14.2675L14.287 17.0564L10.1198 14.2675L14.287 11.4785ZM13.1071 3.92153V9.42435L7.99059 12.8408L3.86625 10.084L13.1071 3.92153ZM2.91696 12.2938L5.87747 14.2675L2.91696 16.2466V12.2938Z" fill="#272735"/>
        </svg>

      </a>

    </li> -->

    <!-- <li class="c-list-socials__item">

      <a :href="socials.twitter" target="_blank" rel="noopener" class="c-list-socials__link">

        <svg class="c-list-socials__svg" width="33" height="26" viewBox="0 0 33 26" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M32.2066 3.59521C31.0479 4.10749 29.8099 4.44291 28.517 4.60757C29.8465 3.81476 30.8588 2.57065 31.3345 1.07041C30.0965 1.80834 28.7304 2.32671 27.2729 2.61944C26.102 1.36924 24.4249 0.594727 22.6014 0.594727C19.0581 0.594727 16.204 3.47324 16.204 6.9982C16.204 7.50438 16.2467 7.99226 16.3504 8.45575C11.0264 8.19961 6.31828 5.64432 3.15314 1.75955C2.59817 2.71702 2.27495 3.81476 2.27495 4.99788C2.27495 7.21775 3.41537 9.18148 5.11687 10.3158C4.08621 10.2975 3.07995 9.99868 2.22616 9.52909C2.22616 9.54739 2.22616 9.57178 2.22616 9.60228C2.22616 12.7125 4.44603 15.2983 7.35503 15.8899C6.83666 16.0301 6.26339 16.1033 5.67793 16.1033C5.26933 16.1033 4.85463 16.0789 4.46432 15.9935C5.29373 18.5305 7.64776 20.3906 10.447 20.4516C8.26981 22.1531 5.50108 23.1837 2.51279 23.1837C1.98832 23.1837 1.48214 23.1593 0.982056 23.0984C3.81788 24.9279 7.17818 25.9708 10.8007 25.9708C22.5831 25.9708 29.0232 16.2131 29.0232 7.75442C29.0232 7.47388 29.011 7.19945 28.9988 6.92502C30.2673 6.02243 31.3345 4.8942 32.2066 3.59521Z" fill="#272735"/>
        </svg>

      </a>

    </li> -->

  </ul>

</template>

<script>

export default {
  name: 'ListSocials',
  props: {
    socials: Object
  }
}
</script>

<style lang="sass">
.c-list-socials
  display: flex
  justify-content: flex-end
  align-items: center

  +break-max($tablet)
    margin-top: 2rem

  &__item
    margin: 0 0.5rem
    +remove-margin-h

  &__link
    +size(6.5rem)
    border: solid 5px $black
    border-radius: 100%
    display: flex
    justify-content: center
    align-items: center
    +transition-25-ease

    +break-max($tablet)
      border-width: 2px

    &:hover
      background-color: $black

      .c-list-socials__svg *
        fill: $powder

  &__svg
    +size(2.5rem)
    *
      fill: $black
      +transition-25-ease
  
</style>
